export default "__VITE_ASSET__Cq$lLH7I__"